import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useAPI from "../../api/hooks/useAPI";
import useColors from "../../api/hooks/useColors";
import { useOnboarding } from "../../contexts/OnboardingContext";
import { ONBOARDING_STEPS } from "../../utils/constants";
import ContainedButton from "../buttons/ContainedButton";

const IntegrationSuccessModal = () => {
  const colors = useColors();
  const { openOnboardingModal, setOnboardingStage, currentStage } =
    useOnboarding();
  const { trackEvent } = useAPI();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (currentStage === ONBOARDING_STEPS.SCAN) {
      setOpen(true);
    }
  }, [currentStage]);

  const handleContinueOnboarding = () => {
    trackEvent("User chose to continue onboarding after integration");
    setOpen(false);
    setOnboardingStage(ONBOARDING_STEPS.SCAN);
    openOnboardingModal();
  };

  const handleClose = () => {
    trackEvent("User closed integration success modal");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "10px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
          Integration Connected Successfully!
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          Your integration has been successfully connected. Would you like to
          continue with the onboarding process?
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <ContainedButton
            color="primary"
            size="large"
            onClick={handleContinueOnboarding}
            fullWidth
          >
            Continue Onboarding
          </ContainedButton>
          <Button
            onClick={handleClose}
            sx={{
              py: 1,
              textTransform: "none",
              color: colors.text_secondary,
            }}
          >
            I'll Do This Later
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default IntegrationSuccessModal;
